module.exports = __webpack_public_path__ + "static/media/S3N4.766e4443.svg";